export default __webpack_public_path__ + "701be389adbdf34468b779154e0cf3c7.svg";